__webpack_require__.p = "/orxfun-notes/";